import LayoutType from '../const/layout_type';

export const getKioskMode = state => state.view.kioskMode;
export const isKioskMode = state => state.view.isKioskMode;
export const getCurrentLayoutType = (state) => {
  switch (state.view.layoutType) {
    case LayoutType.DEFAULT_GRID: {
      return LayoutType.GRID;
    }
    case LayoutType.DEFAULT_LIST: {
      return LayoutType.LIST;
    }
    default: {
      return state.view.layoutType;
    }
  }
};



// WEBPACK FOOTER //
// ./src/selectors/viewSelectors.js